import { PredefinedIcons } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.types';

type QuickSwitchBaseItem = {
	id: string;
	icon: PredefinedIcons;
	label: string;
	dataTestId?: string;
	matchOnlyExactRoutes?: boolean;
	badge?: string;
};

type QuickSwitchLeafItem = QuickSwitchBaseItem & {
	route: string;
};

type QuickSwitchParentItem = QuickSwitchBaseItem & {
	items: { id: string; label: string; route: string }[];
};

export type QuickSwitchConfigItem = QuickSwitchLeafItem | QuickSwitchParentItem;

export const isLeafItem = (item: QuickSwitchConfigItem): item is QuickSwitchLeafItem => {
	return 'route' in item;
};

export const isParentItem = (item: QuickSwitchConfigItem): item is QuickSwitchParentItem => {
	return 'items' in item;
};
